var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/nsips-patient-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-0db4ae40!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/nsips-patient-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/NsipsPatientList.vue
// module id = 329
// module chunks = 1